import { useState } from 'react'
import Customupload from '../../../../components/UploadFile'
import Custompreviewimg from '../../../../components/PreviewUser'
import Style from './upload.module.scss'
import { HTTP } from '../../../../api/http'
import { RcFile } from 'antd/lib/upload'
import { message } from 'antd'
import { Accept } from '../../../../tools/util'
import { UPLOADFILE_PRODUCTION } from '../../../../api/uploadfileapi'
import CustomIcon from '../../../../components/IconUser'
import { CloudUploadOutlined } from '@ant-design/icons'
export interface imgFile {
  url: string
  name?: string
  baseUrl: string
}

interface Props {
  dataSource: imgFile[]
  onChange?: (e: imgFile[]) => void
  productCode?: string
  disable?: boolean
  disableUpload?: boolean
  params?: { code: string; type: string }
}

// 上传文件
const Uploadimg = (props: Props) => {
  const { dataSource, onChange, productCode, disable, params, disableUpload } =
    props
  const [previewimg, setPreviewimg] = useState<{
    data: string[] // 图片url
    currentIndex?: number // 开始索引
  }>({ data: [] })
  // 删除图片
  function onClickDel(index: string) {
    const arr = dataSource.filter((item) => item.url !== index)
    onChange && onChange(arr)
  }

  // 预览图片
  const onClickPreview = (cur: number) => {
    const arr = dataSource.map(
      (item) => `${item.baseUrl ? item.baseUrl : HTTP}${item.url}`,
    )
    setPreviewimg({
      data: arr,
      currentIndex: cur,
    })
  }

  const uploadimg = async (productCode: string, file: RcFile) => {
    try {
      const resData = await UPLOADFILE_PRODUCTION(file, params)
      if (resData.code === 0) {
        const list = resData.data
        message.success('上传成功')
        const arr = [
          {
            url: list.newFilePath,
            name: list.filename,
            baseUrl: list.baseUrl,
          },
        ]
        onChange && onChange(arr)
      }
    } catch (error) {}
  }

  let top = 0
  // 上传之前处理图片
  const beforeUpload = (file: RcFile, FileList: RcFile[]) => {
    if (file.size > 1024 * 1024 * 20) {
      message.error('上传失败：图片大于20m')
      top = 0
      return false
    } else if (file.type.indexOf('image') === -1) {
      message.error('上传失败：请上传图片格式！')
      top = 0
      return false
    } else if (
      !dataSource.every(
        (item) => file.name.indexOf(item.name ? item.name : '') === -1,
      )
    ) {
      message.error('上传失败：图片重复')
      top = 0
      return false
    }
    top++
    // 防止重复提交
    if (top === FileList.length) {
      uploadimg(productCode ? productCode : '', file)
      top = 0
    }
    return false
  }

  return (
    <div className={Style.fileimgbox}>
      <div className={Style.fileimglist}>
        {dataSource.map((item, index) => (
          <div className={Style.fileimgitem} key={index}>
            <div className={Style.fileimgiteminfo}>
              <img
                src={`${item.baseUrl ? item.baseUrl : HTTP}${item.url}`}
                alt={item.name}
              />
              <div
                className={Style.filehide}
                onClick={() => onClickPreview(index)}
              >
                <div style={{ color: '#FFFFFF' }}>点击预览</div>
              </div>
              {disableUpload ? null : (
                <CustomIcon
                  type="icon-shanchu1"
                  onClick={() => onClickDel(item.url)}
                  className={Style.delicon}
                />
              )}
            </div>
          </div>
        ))}
        {disable || dataSource.length >= 1 ? null : (
          <Customupload
            accept={Accept('image')}
            multiple
            disabledUpload={disableUpload}
            uploadBtn={
              <div className={Style.uploadBtn}>
                <p className="ant-upload-drag-icon">
                  <CloudUploadOutlined style={{ fontSize: '36px' }} />
                </p>
                <p className="ant-upload-text">点击选择本地文件</p>
                <div className="ant-upload-hint">支持扩展名：.pdf.jpg...</div>
              </div>
            }
            beforeUpload={(a, b) => beforeUpload(a, b)}
            visibleFile={false}
          />
        )}

        <Custompreviewimg
          onClose={() =>
            setPreviewimg({
              data: [],
            })
          }
          images={previewimg}
        />
      </div>
    </div>
  )
}

export default Uploadimg
import { useState } from 'react'
import Customupload from '../../../../components/UploadFile'
import Custompreviewimg from '../../../../components/PreviewUser'
import Style from './upload.module.scss'
import { HTTP } from '../../../../api/http'
import { RcFile } from 'antd/lib/upload'
import { message } from 'antd'
import { Accept } from '../../../../tools/util'
import { UPLOADFILE_PRODUCTION } from '../../../../api/uploadfileapi'
import CustomIcon from '../../../../components/IconUser'
import { CloudUploadOutlined } from '@ant-design/icons'
export interface imgFile {
  url: string
  name?: string
  baseUrl: string
}

interface Props {
  dataSource: imgFile[]
  onChange?: (e: imgFile[]) => void
  productCode?: string
  disable?: boolean
  disableUpload?: boolean
  params?: { code: string; type: string }
}

// 上传文件
const Uploadimg = (props: Props) => {
  const { dataSource, onChange, productCode, disable, params, disableUpload } =
    props
  const [previewimg, setPreviewimg] = useState<{
    data: string[] // 图片url
    currentIndex?: number // 开始索引
  }>({ data: [] })
  // 删除图片
  function onClickDel(index: string) {
    const arr = dataSource.filter((item) => item.url !== index)
    onChange && onChange(arr)
  }

  // 预览图片
  const onClickPreview = (cur: number) => {
    const arr = dataSource.map(
      (item) => `${item.baseUrl ? item.baseUrl : HTTP}${item.url}`,
    )
    setPreviewimg({
      data: arr,
      currentIndex: cur,
    })
  }

  const uploadimg = async (productCode: string, file: RcFile) => {
    try {
      const resData = await UPLOADFILE_PRODUCTION(file, params)
      if (resData.code === 0) {
        const list = resData.data
        message.success('上传成功')
        const arr = [
          {
            url: list.newFilePath,
            name: list.filename,
            baseUrl: list.baseUrl,
          },
        ]
        onChange && onChange(arr)
      }
    } catch (error) {}
  }

  let top = 0
  // 上传之前处理图片
  const beforeUpload = (file: RcFile, FileList: RcFile[]) => {
    if (file.size > 1024 * 1024 * 20) {
      message.error('上传失败：图片大于20m')
      top = 0
      return false
    } else if (file.type.indexOf('image') === -1) {
      message.error('上传失败：请上传图片格式！')
      top = 0
      return false
    } else if (
      !dataSource.every(
        (item) => file.name.indexOf(item.name ? item.name : '') === -1,
      )
    ) {
      message.error('上传失败：图片重复')
      top = 0
      return false
    }
    top++
    // 防止重复提交
    if (top === FileList.length) {
      uploadimg(productCode ? productCode : '', file)
      top = 0
    }
    return false
  }

  return (
    <div className={Style.fileimgbox}>
      <div className={Style.fileimglist}>
        {dataSource.map((item, index) => (
          <div className={Style.fileimgitem} key={index}>
            <div className={Style.fileimgiteminfo}>
              <img
                src={`${item.baseUrl ? item.baseUrl : HTTP}${item.url}`}
                alt={item.name}
              />
              <div
                className={Style.filehide}
                onClick={() => onClickPreview(index)}
              >
                <div style={{ color: '#FFFFFF' }}>点击预览</div>
              </div>
              {disableUpload ? null : (
                <CustomIcon
                  type="icon-shanchu1"
                  onClick={() => onClickDel(item.url)}
                  className={Style.delicon}
                />
              )}
            </div>
          </div>
        ))}
        {disable || dataSource.length >= 1 ? null : (
          <Customupload
            accept={Accept('image')}
            multiple
            disabledUpload={disableUpload}
            uploadBtn={
              <div className={Style.uploadBtn}>
                <p className="ant-upload-drag-icon">
                  <CloudUploadOutlined style={{ fontSize: '36px' }} />
                </p>
                <p className="ant-upload-text">点击选择本地文件</p>
                <div className="ant-upload-hint">支持扩展名：.pdf.jpg...</div>
              </div>
            }
            beforeUpload={(a, b) => beforeUpload(a, b)}
            visibleFile={false}
          />
        )}

        <Custompreviewimg
          onClose={() =>
            setPreviewimg({
              data: [],
            })
          }
          images={previewimg}
        />
      </div>
    </div>
  )
}

export default Uploadimg
